// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pull-right[data-v-4b41bf40] {\n  float: right;\n}\n.pull-left[data-v-4b41bf40] {\n  float: left;\n}\n.tanked[data-v-4b41bf40] {\n  position: absolute;\n  bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
